export type Orientation = 'Landscape' | 'Portrait';

export enum PlayerState {
  UNSTARTED = -1,
  ENDED = 0,
  PLAYING = 1,
  PAUSED = 2,
  BUFFERING = 3,
  CUED = 5,
}

export type PlayerStateChangeEvent = {
  state: PlayerState;
  currentTime?: number;
  duration?: number;
};

export type YouTubeIframePlayer = {
  playVideo: () => void;
  pauseVideo: () => void;
  seekTo: (seconds: number, allowSeekAhead?: boolean) => void;
};

export type LiteYouTubeElement = HTMLElement & {
  getYTPlayer: () => Promise<YouTubeIframePlayer>;
};

export type YouTubePlayerProps = {
  videoUrl?: string;
  orientation?: Orientation;
  landscapeThumbnailUrl?: string;
  portraitThumbnailUrl?: string;
  onStateChange?: (event: PlayerStateChangeEvent) => void;
  classes?: string;
};

export type YouTubeMessageEvent = {
  event?: 'infoDelivery' | 'onStateChange';
  info?: {
    playerState?: number;
    currentTime?: number;
    duration?: number;
  };
};
